import { createSelector } from '@reduxjs/toolkit';

export const getCall = ()=> {
    return createSelector(
        (state: any) => state?.call,
        (state) => state
    )
}